import { Routes } from "@angular/router"
import { TermsOfServiceComponent } from "./terms-of-service.component"

export const termsOfServiceRoutes: Routes = [
    { path: "", component: TermsOfServiceComponent },
]
